import type { ReactElement } from 'react';
import { Button, Heading, Page, Paragraph } from '@zillow/constellation-10';
import { Pets } from '../../images/Pets';

export function ErrorPage({ errorDetails, errorMessage, homePageText, homePageUrl }: ErrorPageProps): ReactElement {
  return (
    <Page.Root css={{ backgroundColor: 'bg.neutral' }}>
      <Page.Content>
        <Pets />
        <Heading level={1} textStyle="heading-sm">
          {errorMessage}
        </Heading>
        {errorDetails ? (
          <Paragraph textStyle="body-sm" css={{ marginTop: 'sm' }}>
            {errorDetails}
          </Paragraph>
        ) : null}
        {homePageText && homePageUrl && (
          <Button emphasis="filled" tone="brand" css={{ marginTop: 'lg' }} asChild>
            <a href={homePageUrl}>{homePageText}</a>
          </Button>
        )}
      </Page.Content>
    </Page.Root>
  );
}

interface ErrorPageProps {
  errorCode?: number;
  errorMessage?: string;
  errorDetails?: React.ReactNode;
  homePageText?: string;
  homePageUrl?: string;
}
